export default "__VITE_ASSET__BApeUe8P__"